const SEARCH_LABELS: { container: string; input: string; text: string; placeholder?: string }[] = [
    { container: '.attrax-form-item', input: '.attrax-form-item__input', text: '{{js.hero-search_label}}', placeholder: '{{js.hero-search_placeholder}}' },
    { container: '.location-search', input: '.location-search-input', text: '{{js.hero-location-label}}' },
]

export const initialise = () => {
    if (!document.body.classList.contains('page-home')) return

    homeVideo()
    searchLabels()
}

const searchLabels = () => {
    const widget = document.querySelector<HTMLElement>('.page-home__hero .attrax-search-widget')
    if (!widget) return

    SEARCH_LABELS.forEach(({ container, input, text, placeholder }) => {
        const field = widget.querySelector<HTMLElement>(container)
        const inputEl = widget.querySelector<HTMLElement>(input)
        if (!field || !inputEl) return

        if (placeholder && inputEl instanceof HTMLInputElement) {
            inputEl.placeholder = placeholder
        }

        if (field.querySelector('.attrax-search-widget__field-label')) return

        const label = document.createElement('span')
        label.className = 'attrax-search-widget__field-label'
        label.textContent = text
        label.setAttribute('aria-hidden', 'true')
        field.insertBefore(label, field.firstChild)
    })
}

const homeVideo = () => {
    const banner = document.querySelector<HTMLElement>('.page-home__hero .banner-pool-widget')
    if (!banner) return
    const video = banner.querySelector<HTMLIFrameElement>('iframe')
    if (!video) return

    video.addEventListener('load', () => {
        video.classList.add('loaded')
    })

    const src = video.src
    if (src) {
        const videoIdMatch: RegExpMatchArray | null = src.match(/embed\/([^?]+)/)
        const videoId: string = videoIdMatch ? videoIdMatch[1] : ''
        const separator: string = src.includes('?') ? '&' : '?'
        video.src = `${src}${separator}autoplay=1&mute=1&loop=1&controls=0&disablekb=1&rel=0&enablejsapi=1&playlist=${videoId}`
    }

    addVideoToggle(banner, video)
}

const addVideoToggle = (banner: HTMLElement, video: HTMLIFrameElement) => {
    const controls = document.createElement('div')
    controls.className = 'page-home__hero-banner__video-controls'

    const btn = document.createElement('button')
    btn.className = 'page-home__hero-banner__video-toggle'
    btn.setAttribute('aria-label', 'Pause video')
    btn.setAttribute('type', 'button')

    controls.appendChild(btn)

    const customHtml = banner.querySelector('.banner-customhtml')
    if (customHtml) {
        customHtml.appendChild(controls)
    }

    let playing = true

    btn.addEventListener('click', () => {
        if (playing) {
            video.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*')
            btn.classList.add('paused')
            btn.setAttribute('aria-label', 'Play video')
        } else {
            video.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*')
            btn.classList.remove('paused')
            btn.setAttribute('aria-label', 'Pause video')
        }
        playing = !playing
    })
}
